import { Button, Input, Radio, Select, Spin } from 'antd';
import NachWrapper from 'features/nach/components/NachWrapper';
import Form, { Rule } from 'antd/lib/form';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { NACH_ROUTE } from 'features/nach/routes';
type FormInputType = {
  name: string;
  label?: string;
  Component?: React.ReactNode;
  required?: boolean;
  rules?: any;
};

const FormInput = ({ name, label, Component, rules, required }: FormInputType) => {
  return (
    <div className="form-group col-xs-12 col-sm-6 col-md-6">
      <div className="input-box">
        <Form.Item label={label} required={required} rules={rules} name={name}>
          {Component}
        </Form.Item>
      </div>
    </div>
  );
};

function BankMasterUpdate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isFormChanged, setIsFormChanged] = useState(false);
  const { Option } = Select;

  const location = useLocation();
  const rules: Rule[] = [
    {
      type: 'string',
      required: true,
    },
  ];
  useEffect(() => {
    if (!location.state) {
      navigate(NACH_ROUTE.bank_master.to);
    }
    console.log('location.state', location.state);
    form.setFieldsValue(location.state);
    // console.log(location.state);
  }, []);

  const formSubmitHandler = () => {
    // console.log(location.state);
    console.log(form.getFieldsValue());
    setTimeout(() => {
      navigate(NACH_ROUTE.bank_master.to);
    }, 1000);
  };
  const handleFormChange = (changedValues: any, allValues: any) => {
    console.log(changedValues, allValues);
    setIsFormChanged(true);
  };

  return (
    <NachWrapper>
      <Spin spinning={false}>
        <Form
          layout="vertical"
          onValuesChange={handleFormChange}
          onFinish={formSubmitHandler}
          form={form}
          scrollToFirstError
          className="standard-forms"
        >
          <div className="row">
            <FormInput required rules={rules} name="BankId" label="Bank Id" Component={<Input />} />
            <FormInput
              name="NachType"
              label="NACH Type"
              Component={
                <Select placeholder="Nach Type" size="large">
                  <Option value="P-NACH">P-NACH</Option>
                  <Option value="E-NACH">E-NACH</Option>
                  <Option value="both">Both</Option>
                </Select>
              }
            />
            <FormInput
              name="BankName"
              label="Bank Name"
              required
              rules={rules}
              Component={<Input />}
            />
            <FormInput
              required
              rules={rules}
              name="Status"
              label="Status"
              Component={
                <Radio.Group size="large">
                  <Radio style={{ fontSize: '15px', fontWeight: '600' }} value={'Active'}>
                    Active
                  </Radio>
                  <Radio style={{ fontSize: '15px', fontWeight: '600' }} value={'Inactive'}>
                    Inactive
                  </Radio>
                </Radio.Group>
              }
            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '4px',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type="primary"
              className="proceed-btn"
              id="btnSubmit"
              htmlType="submit"
              size="small"
              disabled={!isFormChanged}
            >
              Update
            </Button>
            <Button
              type="primary"
              className="proceed-btn"
              id="btnSubmit"
              size="small"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </div>
        </Form>
      </Spin>
    </NachWrapper>
  );
}
export default BankMasterUpdate;
